<template></template>

<script>
    import FroalaEditor from 'froala-editor';
    import { mapState } from 'vuex';
    import { EventBus } from '../lib/event-bus'

    // component that renders the custom buttons for the froala huddle editor
    export default {
        name: 'HuddleEditorV2Main',

        computed: {
            ...mapState(['active_editor_v2_uuid']),
        },

        mounted() {
            // define image button
            FroalaEditor.DefineIcon('images', {NAME: 'image'});
            FroalaEditor.RegisterCommand('images', {
                focus: false,
                undo: false,
                refreshAfterCallback: false,
                callback: () => {
                    EventBus.$emit(`image-btn-clicked-${this.active_editor_v2_uuid}`);
                },
            });

            // define gifs button
            FroalaEditor.DefineIcon('gifs', {NAME: 'GIFs'});
            FroalaEditor.RegisterCommand('gifs', {
                icon: '<p>GIF</p>',
                focus: true,
                undo: false,
                refreshAfterCallback: false,
                callback: () => {
                    EventBus.$emit(`gif-btn-clicked-${this.active_editor_v2_uuid}`);
                },
            });

            // define emojis button
            FroalaEditor.DefineIcon('emojis', {NAME: 'smile'});
            FroalaEditor.RegisterCommand('emojis', {
                focus: true,
                undo: false,
                refreshAfterCallback: false,
                callback: () => {
                    EventBus.$emit(`emoji-btn-clicked-${this.active_editor_v2_uuid}`);
                },
            });

            // define emojis button
            FroalaEditor.DefineIcon('submit', {NAME: 'share'});
            FroalaEditor.RegisterCommand('submit', {
                focus: false,
                undo: false,
                refreshAfterCallback: false,
                callback: () => {
                    EventBus.$emit(`submit-btn-clicked-${this.active_editor_v2_uuid}`);
                },
            });
        },
    };
</script>
